var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.props)?_c('nav',{staticClass:"navigation"},[_c('Desktop',{staticClass:"navigation--desktop",attrs:{"props":_vm.props}}),_c('Mobile',{staticClass:"navigation--mobile",attrs:{"props":_vm.props}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63f99e5c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/navigation.pug
// module id = agI8
// module chunks = 1